import { render } from "./AboutUsPage.vue?vue&type=template&id=e544b7fa&scoped=true"
const script = {}

import "./AboutUsPage.vue?vue&type=style&index=0&id=e544b7fa&scoped=true&lang=css"

import exportComponent from "/home/user/ade-home/chantiervocal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e544b7fa"]])

export default __exports__